import { Typography } from '@material-ui/core';
import withWidth from '@material-ui/core/withWidth';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ActionText from '../../core/ActionText';
import CreateButton from '../../core/CreateButton';
import ConceptData from './ConceptData';
import SchemeData from './SchemeData';
import CreateTopConceptDialogContainer from './CreateTopConceptDialogContainer';
import TaxonomySearch from './TaxonomySearch';
import TaxonomyStructure from './TaxonomyStructure';
import { globalStyles } from '../../core/style/gstheme';
import GetStarted from '../../application-core/GetStarted';
import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';

const styles = Object.assign({}, globalStyles);

class TaxonomyView extends Component {

  render() {

    const { activeConcept, classes, schemeIRI, onSelect, onAddNewConcept, onAddExistingConcept, projectUsers,
      expandConcept, collapseConcept, selectedTitlePath, showFloatingLabel, onSetMode, onCollapse,
      data, appBar, foundRef, defaultLang, foundPath, showLabelDetail, skosXL, viewWidth, width, taxonomies, collections,
      onFoundConcept, onSelectViewLanguage, addToScheme, titlePath, onFullViewChange, onViewWidthChange,
      foundTime, onDeleteConcept, onBreakLink, isReadOnly, expandedPaths, isFullView, iriOptions,
      project, viewLang, graph, useSlashIRI, useUuidIRI, move, entitlements } = this.props;

    const isLargeScreen = width === "lg" || width === "xl";

    return (
      <div>
        <div data-test="left-panel"
          className={classes.controlPanel}
          style={{
            ...(isFullView) && { width: 'calc(100% - 100px)' },
            ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (340 + (viewWidth * 100)) }
          }}>
          <div className={classes.views}>
            {appBar}
          </div>
          <div className={classes.controlPanelInner}>
            <div data-test="add-top-concept" className={classes.controlPanelAdd}>
              {!isReadOnly && data.hasTopConcept && data.hasTopConcept.length > 0 &&
                <CreateTopConceptDialogContainer
                  schemeIRI={schemeIRI}
                  graph={graph}
                  useXL={data.useXL}
                  useWorkflow={data.activateWorkflow === true}
                  iriOptions={iriOptions}
                  useSlashIRI={useSlashIRI}
                  useUuidIRI={useUuidIRI}
                  onAddExistingConcept={onAddExistingConcept(titlePath, "")}
                  onAddNewConcept={onAddNewConcept(titlePath, "")}
                />
              }
            </div>
            <div className={classes.controlPanelSearch}>
              {data.hasTopConcept && data.hasTopConcept.length > 0 &&
                <TaxonomySearch
                  project={project}
                  useWorkflow={data.activateWorkflow === true}
                  onFoundConcept={onFoundConcept}
                  skosXL={skosXL}
                  defaultLang={viewLang || defaultLang}
                  schemeIRI={schemeIRI} />
              }
            </div>
          </div>
          <div data-test="concept-tree"
            className={classes.tree}
            style={
              {
                ...(isFullView) && { width: 'calc(100% - 100px)' },
                ...(!isFullView && isLargeScreen && viewWidth !== 0) && { width: (340 + (viewWidth * 100)) }
              }
            }>
            {data.hasTopConcept && data.hasTopConcept.length > 0 &&
              <div className={classes.treeOptions}>
                <div data-test="editing-mode" style={{ paddingTop: 4, paddingBottom: 4, overflow: 'auto' }}>
                  {data.editingMode !== "Poly" && data.editingMode !== "Mono" &&
                    <React.Fragment>
                      <Tooltip title="Polyhierarchy mode">
                        <span data-test={"poly-selected-" + !move} onClick={() => onSetMode(false)}>
                          <IconButton data-test={"option-poly"} size="small" classes={!move ?
                            {
                              root: this.props.classes.selectedOption
                            }
                            :
                            null}>
                            <CallSplitIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Monohierarchy mode">
                        <span data-test={"mono-selected-" + move} onClick={() => onSetMode(true)} style={{ marginLeft: 4 }}>
                          <IconButton data-test={"option-move"} size="small" classes={move ?
                            {
                              root: this.props.classes.selectedOption
                            }
                            :
                            null}>
                            <ArrowUpwardIcon />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </React.Fragment>
                  }
                  <Tooltip title="Collapse all">
                    <span data-test={"collapse-all"} onClick={onCollapse} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-collapse-all"} size="small">
                        <UnfoldLessIcon />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <Tooltip title="Toggle full view mode">
                    <span data-test={"full-view"} onClick={onFullViewChange} style={{ float: 'right', marginLeft: 4 }}>
                      <IconButton data-test={"option-full-view"} size="small">
                        {isFullView ?
                          <FullscreenExitIcon />
                          :
                          <FullscreenIcon />
                        }
                      </IconButton>
                    </span>
                  </Tooltip>
                  {isLargeScreen &&
                    <Tooltip title="Change hierarchy width">
                      <span data-test={"split-view-" + viewWidth} onClick={onViewWidthChange} style={{ float: 'right' }}>
                        <IconButton data-test={"option-split"} size="small">
                          <VerticalSplitIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  }
                </div>
              </div>
            }
            {data.hasTopConcept && data.hasTopConcept.length > 0 && data.hasTopConcept.length < 5000 ?
              <TaxonomyStructure
                defaultLang={defaultLang}
                viewLang={viewLang}
                version={data.version}
                foundPath={foundPath}
                iriOptions={iriOptions}
                activeConcept={activeConcept}
                foundRef={foundRef}
                foundTime={foundTime}
                expandedPaths={expandedPaths}
                onAddNewConcept={onAddNewConcept}
                onDeleteConcept={onDeleteConcept}
                expandConcept={expandConcept}
                selectedTitlePath={selectedTitlePath}
                titlePath={titlePath}
                titleTree={[]}
                collapseConcept={collapseConcept}
                onAddExistingConcept={onAddExistingConcept}
                schemeIRI={schemeIRI}
                skosXL={skosXL}
                useXL={data.useXL}
                useWorkflow={data.activateWorkflow === true}
                useSlashIRI={useSlashIRI}
                useUuidIRI={useUuidIRI}
                childProperty='hasTopConcept'
                data={data}
                path=""
                graph={graph}
                isReadOnly={isReadOnly}
                concepts={data.hasTopConcept ? data.hasTopConcept : []}
                onSelect={onSelect}
                addToScheme={addToScheme}
                onBreakLink={onBreakLink}
                loadOptions={{
                  language: viewLang && viewLang !== defaultLang ? [defaultLang, viewLang] : defaultLang
                }}
              />
              :
              data.hasTopConcept && data.hasTopConcept.length >= 5000 ?
                <ActionText offset="85px">Too many top level concepts to display.</ActionText>
                :
                (isReadOnly ?
                  <ActionText offset="85px">No concepts.</ActionText>
                  :
                  <GetStarted text="Add a concept to get started." action={
                    <CreateTopConceptDialogContainer
                      schemeIRI={schemeIRI}
                      useXL={data.useXL}
                      useWorkflow={data.activateWorkflow === true}
                      useSlashIRI={useSlashIRI}
                      useUuidIRI={useUuidIRI}
                      iriOptions={iriOptions}
                      graph={graph}
                      disableMultiple={true}
                      button={<CreateButton label="Add" />}
                      onAddExistingConcept={onAddExistingConcept(titlePath, "")}
                      onAddNewConcept={onAddNewConcept(titlePath, "")}
                    />
                  } />
                )
            }
          </div>
        </div>
        <div data-test="language-panel" className={classes.viewLanguagePanel}>
          <ProjectLanguageSelector selectedLang={viewLang} includeLabel={false} onSelect={onSelectViewLanguage} />
        </div>
        {!isFullView &&
          <div data-test="info-panel"
            className={classes.infoPanel}
            style={
              {
                ...(!isFullView && viewWidth !== 0) && { left: (380 + (viewWidth * 100)) }
              }
            }>
            {
              data.hasTopConcept && data.hasTopConcept.length > 0 ?
                (activeConcept === null ?
                  <SchemeData
                    key={schemeIRI}
                    entitlements={entitlements}
                    schemeIRI={schemeIRI}
                    useWorkflow={data.activateWorkflow === true}
                    viewLang={viewLang}
                    iriOptions={iriOptions}
                    useXL={data.useXL}
                    isReadOnly={isReadOnly}
                    collections={collections}
                    taxonomies={taxonomies}
                    defaultClasses={data.defaultClass}
                    graph={graph}
                    useSlashIRI={useSlashIRI}
                    useUuidIRI={useUuidIRI}
                    project={project} />
                  :
                  <ConceptData
                    key={activeConcept}
                    expectedTypes={["Concept"]}
                    handleNotAvailable={true}
                    id={activeConcept}
                    entitlements={entitlements}
                    schemeIRI={schemeIRI}
                    viewLang={viewLang}
                    iriOptions={iriOptions}
                    onFoundConcept={onFoundConcept}
                    defaultClasses={data.defaultClass}
                    move={move}
                    projectUsers={projectUsers}
                    taxonomies={taxonomies}
                    propertyTemplates={data.associatedTemplate}
                    hiddenProps={data.hiddenProp}
                    graph={graph}
                    useSlashIRI={useSlashIRI}
                    useUuidIRI={useUuidIRI}
                    linkedData={data.linkedData}
                    associatedProject={data.associatedProject ?
                      Array.isArray(data.associatedProject) ?
                        data.associatedProject
                        :
                        [data.associatedProject]
                      :
                      []
                    }
                    useXL={data.useXL}
                    useWorkflow={data.activateWorkflow === true}
                    showFloatingLabel={showFloatingLabel}
                    showLabelDetail={showLabelDetail}
                    project={project}
                    conceptIRI={activeConcept}
                    onDeleteConcept={onDeleteConcept} />
                )
                :
                <div>
                  <div data-test="hint-1" style={{ margin: '6px 12px', backgroundColor: '#f5f5f5', padding: '0px 12px 6px 12px', boxShadow: '0px 3px 6px #00000029', borderRadius: 4, border: 'solid 1px #f0f0f0', width: 180 }}>
                    <Typography variant="caption">Click on the taxonomy title <ArrowUpwardIcon style={{ transform: 'translate(0px, 6px)' }} /> or the settings icon to manage the taxonomy.</Typography>
                  </div>
                  <ActionText offset="180px">When concepts are created you will be able to view the detail here.</ActionText>
                </div>
            }
          </div>
        }
      </div>
    );
  }
}

TaxonomyView.defaultProps = {
  viewWidth: 0
};

TaxonomyView.propTypes = {
  onSetMode: PropTypes.func.isRequired,
  entitlements: PropTypes.array.isRequired,
  schemeIRI: PropTypes.string.isRequired,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  data: PropTypes.object,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  activeConcept: PropTypes.string,
  appBar: PropTypes.object.isRequired,
  skosXL: PropTypes.bool.isRequired,
  editingMode: PropTypes.string,
  titlePath: PropTypes.array,
  project: PropTypes.string.isRequired,
  expandConcept: PropTypes.func.isRequired,
  collapseConcept: PropTypes.func.isRequired,
  onAddExistingConcept: PropTypes.func.isRequired,
  onAddNewConcept: PropTypes.func.isRequired,
  onFoundConcept: PropTypes.func,
  onDeleteConcept: PropTypes.func.isRequired,
  foundPath: PropTypes.string,
  showFloatingLabel: PropTypes.func.isRequired,
  showLabelDetail: PropTypes.func.isRequired,
  foundTime: PropTypes.number,
  foundRef: PropTypes.object,
  projectUsers: PropTypes.array,
  graph: PropTypes.string.isRequired,
  onSelectViewLanguage: PropTypes.func.isRequired,
  version: PropTypes.string,
  isReadOnly: PropTypes.bool.isRequired,
  move: PropTypes.bool,
  viewWidth: PropTypes.number,
  collections: PropTypes.array,
  taxonomies: PropTypes.array,
  onCollapse: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  addToScheme: PropTypes.func.isRequired,
  onBreakLink: PropTypes.func.isRequired,
  isFullView: PropTypes.bool,
  onFullViewChange: PropTypes.func.isRequired,
  onViewWidthChange: PropTypes.func.isRequired,
  classes: PropTypes.object,
  iriOptions: PropTypes.object
};

export default withWidth()(withStyles(styles)(TaxonomyView));